import ApiRequest from '@/plugins/axios'

export default {
  login (data) {
    return ApiRequest.post('auth/login', data)
  },
  async getRemainingSessionTime (sessionId) {
    return ApiRequest.get('auth/get-remaining-session-time?dontExtendSession=1', {
      headers: {
        'X-Session-Id': sessionId
      }
    })
  },
  status (sessionId) {
    return ApiRequest.get('auth/status', {
      headers: {
        'X-Session-Id': sessionId
      }
    })
  }
}
